export default __webpack_public_path__ + "static/media/lpi.cf90da82.svg";